import { render } from "./AttivitaEditDialog.vue?vue&type=template&id=a54580dc&scoped=true"
import script from "./AttivitaEditDialog.vue?vue&type=script&lang=js"
export * from "./AttivitaEditDialog.vue?vue&type=script&lang=js"

import "./AttivitaEditDialog.vue?vue&type=style&index=0&id=a54580dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54580dc"]])

export default __exports__